export default __webpack_public_path__ + "static/03_DearSaskia-7e79e787ae7265ec64e1684ac0e07180.pdf";